import React from "react";
import "./styles.scss";

const Verdict = (props) => {
  const verdict = props.verdict || props.row?.original?.verdict;
  return <div className={`verdict verdict__${verdict?.toLowerCase()}`}>{verdict}</div>;
};

export default Verdict;
